// components/FullPageChat/FullPageChat.js
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowLeft } from "react-icons/fa";
import ChatPanel from "../ChatSection/ChatPanel";
import { useChat } from "../ChatSection/useChat";
import { PAGE_META } from "../../data/pageMeta";
import usePageMeta from "../../usePageMeta";
import "../ChatSection/Chat.css";
import "./FullPageChat.css";

export default function FullPageChat() {
  // Same session-persisted conversation as the floating chat, so it carries over
  const chat = useChat();
  const inputRef = useRef(null);

  usePageMeta({ ...PAGE_META["/chat"], path: "/chat" });

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <motion.main
      className="FullPageChat-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="FullPageChat-frame">
        <ChatPanel
          ref={inputRef}
          chat={chat}
          variant="page"
          headerActions={
            <Link to="/" className="chat-icon-btn chat-back-btn" aria-label="Back to portfolio" title="Back to portfolio">
              <FaArrowLeft aria-hidden="true" />
              <span className="d-none d-sm-inline">Portfolio</span>
            </Link>
          }
        />
      </div>
    </motion.main>
  );
}
